// Angular
import { Component, HostBinding, OnInit, Input, Injector } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
// RxJS
import { filter } from 'rxjs/operators';
// Translate
import { TranslationService } from '../../../../../core/_base/layout';
import { AppComponentBase } from '../../../../../../shared/app-component-base';
import * as _ from 'lodash';
import { ChangeUserLanguageDto, UserServiceProxy } from '../../../../../../shared/service-proxies/service-proxies';

/* interface LanguageFlag {
	lang: string;
	name: string;
	flag: string;
	active?: boolean;
} */

declare const abp;

@Component({
	selector: 'kt-language-selector',
	templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent extends AppComponentBase implements OnInit {
	// Public properties
	@HostBinding('class') classes = '';
	@Input() iconType: '' | 'brand';


	languages: abp.localization.ILanguageInfo[];
	currentLanguage: abp.localization.ILanguageInfo;


	/*
		language: LanguageFlag;
		languages: LanguageFlag[] = [
			{
				lang: 'en',
				name: 'English',
				flag: './assets/media/flags/260-united-kingdom.svg'
			},
			{
				lang: 'ch',
				name: 'Mandarin',
				flag: './assets/media/flags/034-china.svg'
			},
			{
				lang: 'es',
				name: 'Spanish',
				flag: './assets/media/flags/128-spain.svg'
			},
			{
				lang: 'jp',
				name: 'Japanese',
				flag: './assets/media/flags/063-japan.svg'
			},
			{
				lang: 'de',
				name: 'German',
				flag: './assets/media/flags/162-germany.svg'
			},
			{
				lang: 'fr',
				name: 'French',
				flag: './assets/media/flags/195-france.svg'
			},
		];
		*/


	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	
	constructor(private translationService: TranslationService, private router: Router) {
	}
 */

	constructor(
		injector: Injector,
		private _userService: UserServiceProxy

	) {
		super(injector);


	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		/* this.setSelectedLanguage();
		this.router.events
			.pipe(filter(event => event instanceof NavigationStart))
			.subscribe(event => {
				this.setSelectedLanguage();
			}); */


		this.languages = _.filter(this.localization.languages, l => !l.isDisabled);
		this.currentLanguage = this.localization.currentLanguage;


	}

	/**
	 * Set language
	 *
	 * @param lang: any
	 
	setLanguage(lang) {
		this.languages.forEach((language: LanguageFlag) => {
			if (language.lang === lang) {
				language.active = true;
				this.language = language;
			} else {
				language.active = false;
			}
		});
		this.translationService.setLanguage(lang);
	}
*/
	/**
	 * Set selected language
	 
	setSelectedLanguage(): any {
		this.setLanguage(this.translationService.getSelectedLanguage());
	}
*/


	/**
	 * New Methods
	 * Hasan - 15.03.2020
	 */

	changeLanguage(languageName: string): void {

		const input = new ChangeUserLanguageDto();
		input.languageName = languageName;


		this._userService.changeLanguage(input).subscribe(() => {
			//alert(input.languageName);
			abp.utils.setCookieValue(
				'Abp.Localization.CultureName',
				languageName,
				new Date(new Date().getTime() + 5 * 365 * 86400000), // 5 year
				abp.appPath
			);

			location.reload();
		});
	}

}
